export const LOAD_BALANCES = 'LOAD_BALANCES';
export const LOAD_AML_BALANCE = 'LOAD_AML_BALANCE';
